import { Calendar } from 'primereact/calendar';
import { classNames } from 'primereact/utils';
import React from 'react';
import Flex from '../shared-styles/flexi';

function DatePicker({ value, label = '', error = '', width = '300px', onChange, ...props }) {
    return (
        <Flex direction='column' alignItems='start'>
            <label htmlFor="date" className="font-bold mr-2">
                {label}
            </label>

            <Calendar
                {...props}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                style={{ width: width }}
                required
                className={classNames({ 'p-invalid': error })}
                placeholder={label || 'Select a date'}
            />
            {error && <small className="p-error"> {error} </small>}
        </Flex>
    );
}

export default DatePicker;
